import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoFaceid24 = t0 => {
  const $ = _c(8);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <path d="M8.875 5.125H5.95833C5.4981 5.125 5.125 5.4981 5.125 5.95833V8.875M5.125 15.125V18.0417C5.125 18.5019 5.4981 18.875 5.95833 18.875H8.875M15.125 5.125H18.0417C18.5019 5.125 18.875 5.4981 18.875 5.95833V8.875M18.875 15.125V18.0417C18.875 18.5019 18.5019 18.875 18.0417 18.875H15.125M12.2083 9.29167V11.1667C12.2083 12.0166 11.5722 12.7179 10.75 12.8204M8.45833 9.29167V10.5417M15.5417 9.29167V10.5417M9.5 15.0811C10.2354 15.5065 11.0892 15.75 12 15.75C12.9107 15.75 13.7646 15.5065 14.5 15.0811" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== ariaLabel || $[5] !== className || $[6] !== t2) {
    t3 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}</svg>;
    $[4] = ariaLabel;
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default IcoFaceid24;